import React from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { pxTransform } from "../_util/px-transform";
import { useConfig } from "../_util/use-config";
export function Loading(_a) {
    var _b;
    var vertical = _a.vertical, size = _a.size, color = _a.color, className = _a.className, _c = _a.style, style = _c === void 0 ? {} : _c, children = _a.children;
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, { className: classNames(classPrefix + "-loading", className, (_b = {},
            _b[classPrefix + "-loading--vertical"] = vertical,
            _b)), style: style },
        React.createElement(View, { className: classPrefix + "-loading__icon", style: size
                ? {
                    color: color,
                    width: typeof size === "number" ? pxTransform(size, 750) : size,
                    height: typeof size === "number" ? pxTransform(size, 750) : size,
                }
                : { color: color } },
            React.createElement(View, { className: classPrefix + "-loading--circular" })),
        React.createElement(View, { className: classPrefix + "-loading__text" }, children)));
}
//# sourceMappingURL=Loading.js.map